import { contracterConstants, uriConstants} from '../constants'
import { defaultService } from '../services'
import { alertActions } from './'
import { errorMessages } from '../messages'

export const contracterActions = {
  contracter,
  setContracter,
  toggleType,
  close,
  guideType,
  alert,
  load,

  //구매확인서
  getDocNum,
  issueDoc,
  saveStep1,
  saveStep,
  setCalled,

  deleteTempDoc,
  deleteStepItems,
  deleteStepItemAll,
  updateCurrency,

  isShowItems,
  selectItems,
}


/**
 * 구매확인서 저장정보 조회
 * @returns {function(*): void}
 */
function load(seq) {
  return dispatch => {
    dispatch(apiRequest(contracterConstants.GET_CONFIRMATION_REQUEST))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_ISSUE + seq,
    })
        .then(
            response => {
              dispatch(apiSuccess(contracterConstants.GET_CONFIRMATION_SUCCESS, response))
            },
            error => {
              dispatch(apiFailure(contracterConstants.GET_CONFIRMATION_FAILURE, error))
              dispatch(alertActions.success({
                title: '오류',
                message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
                params: {
                  type: 'success',
                  callback: () => {
                    window.location.replace('/service/inbox');
                  }
                }
              }))
            }
        )
  }
}

/**
 * 구매확인서 문서번호 채번
 * @param params
 * @returns {function(*): void}
 */
function getDocNum(params) {
  return dispatch => {
    dispatch(apiRequest(contracterConstants.GET_DOCNUM_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.CHECK_UTH_GET_DOCNUM + paramStr,
    })
        .then(
            response => {
              dispatch(apiSuccess(contracterConstants.GET_DOCNUM_SUCCESS, response))
            },
            error => {
              dispatch(apiFailure(contracterConstants.GET_DOCNUM_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}

/**
 * 구매확인서 1스탭 임시저장(일반정보)
 * @param params
 * @returns {function(*): void}
 */
function saveStep1(params) {
  return dispatch => {

    dispatch(apiRequest(contracterConstants.TEMP_SAVE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);

    defaultService.handleService({
      method: 'post',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_ACTION_STEP + "1",
      params: paramStr,
    })
        .then(
            response => {
              dispatch(success(contracterConstants.TEMP_SAVE_SUCCESS, response, params))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_SAVE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
  function success(type, response, docInfo) {
    return {
      type: type,
      response,
      docInfo,
    }
  }
}

/**
 * 구매확인서 2~4스탭 임시저장(일반정보)
 * @param params
 * @returns {function(*): void}
 */
function saveStep(docid, step, params, isEdit = false) {
  params.crtIssueSeq = JSON.parse(sessionStorage.getItem(docid))?.step1?.crtIssueSeq;
  delete params.modDt;
  delete params.regDt;

  return dispatch => {
    dispatch(apiRequest(contracterConstants.TEMP_SAVE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);

    defaultService.handleService({
      method: isEdit === true ? 'put' : 'post',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_ACTION_STEP + step,
      params: paramStr,
    })
        .then(
            response => {
              let totalData = JSON.parse(sessionStorage.getItem(docid));
              let list = totalData?.['step' + step];
              let itemKey = step === '2' ? 'crtItemSeq' : step === '3' ? 'crtFileSeq' : 'crtTaxSeq';

              let idx = list?.findIndex(item => item[itemKey] === params[itemKey]);

              let obj = response.data.payload;

              if (idx < 0) {
                list.push(obj);
              } else {
                list.splice(idx, 1, obj);
              }

              totalData['step' + step] = list;

              sessionStorage.setItem(docid, JSON.stringify(totalData));
              dispatch(success(response, list, step))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_SAVE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
  function success(response, list, step) {
    return {
      type: contracterConstants.TEMP_SAVE_SUCCESS_LIST,
      response,
      list,
      step,
    }
  }
}

/**
 * 선택 아이템 삭제
 * @param docid
 * @param step
 * @param delList
 */
function deleteStepItems(docid, step, delList) {
  let totalData = JSON.parse(sessionStorage.getItem(docid));
  let paramKey = step === '2' ? 'crtItemSeqs' : step === '3' ? 'crtFileSeqs' : 'crtTaxSeqs';

  return dispatch => {
    dispatch(apiRequest(contracterConstants.TEMP_SAVE_REQUEST))
    let reqObj = {
      crtIssueSeq: totalData?.step1?.crtIssueSeq,
      [paramKey]: delList,
    }

    defaultService.handleService({
      method: 'patch',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_ACTION_STEP + "del/" + step,
      params: reqObj,
    })
        .then(
            response => {
              let totalData = JSON.parse(sessionStorage.getItem(docid));
              let list = totalData?.['step' + step];
              let itemKey = step === '2' ? 'crtItemSeq' : step === '3' ? 'crtFileSeq' : 'crtTaxSeq';

              delList.forEach((delItem) => {
                list = list?.filter(localItem => (localItem[itemKey] + "") !== (delItem + ""));
              })

              totalData['step' + step] = list;
              sessionStorage.setItem(docid, JSON.stringify(totalData));
              dispatch(success(response, list, step))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_SAVE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
  function success(response, list, step) {
    return {
      type: contracterConstants.TEMP_SAVE_SUCCESS_LIST,
      response,
      list,
      step,
    }
  }
}

/**
 * 스탭에 해당하는 전체 아이템 삭제
 * @param docid
 * @param step
 */
function deleteStepItemAll(docid, step) {
  let totalData = JSON.parse(sessionStorage.getItem(docid));

  return dispatch => {
    dispatch(apiRequest(contracterConstants.TEMP_SAVE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify({crtIssueSeq: totalData?.step1?.crtIssueSeq});

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_ACTION_STEP + 'del-all/'+ step,
      params: paramStr,
    })
        .then(
            response => {
              let totalData = JSON.parse(sessionStorage.getItem(docid));
              totalData['step' + step] = [];
              sessionStorage.setItem(docid, JSON.stringify(totalData));
              dispatch(success(response, [], step))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_SAVE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
  function success(response, list, step) {
    return {
      type: contracterConstants.TEMP_SAVE_SUCCESS_LIST,
      response,
      list,
      step,
    }
  }
}

/**
 * 환율정보 변경
 */
function updateCurrency(docid, currency) {
  let totalData = JSON.parse(sessionStorage.getItem(docid));

  return dispatch => {
    dispatch(apiRequest(contracterConstants.TEMP_SAVE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify({crtIssueSeq: totalData?.step1?.crtIssueSeq, totamtcur: currency});

    defaultService.handleService({
      method: 'patch',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_ACTION_STEP + 'currency/2',
      params: paramStr,
    })
        .then(
            response => {
              let data = JSON.parse(sessionStorage.getItem(docid));
              (data.step2).map(item => item.totamtcur = currency);
              sessionStorage.setItem(docid, JSON.stringify(data));
              dispatch(success(response, data.step2, '2'))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_SAVE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
  function success(response, list, step) {
    return {
      type: contracterConstants.TEMP_SAVE_SUCCESS_LIST,
      response,
      list,
      step,
    }
  }
}

/**
 * 임시저장문서 삭제
 */
function deleteTempDoc(crtIssueSeq) {
  return dispatch => {
    dispatch(apiRequest(contracterConstants.TEMP_DELETE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify({crtIssueSeq});

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_DELETE,
      params: paramStr,
    })
        .then(
            response => {
              dispatch(apiSuccess(contracterConstants.TEMP_DELETE_SUCCESS, response))
            },
            error => {
              dispatch(apiFailure(contracterConstants.TEMP_DELETE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}


/**
 * 문서 발급신청
 */
function issueDoc(crtIssueSeq) {
  return dispatch => {
    dispatch(apiRequest(contracterConstants.ISSUE_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify({crtIssueSeq});

    defaultService.handleService({
      method: 'post',
      endPoint: uriConstants.API_URI + uriConstants.ISSUE_SUBMIT,
      params: paramStr,
    })
        .then(
            response => {
              dispatch(apiSuccess(contracterConstants.ISSUE_SUCCESS, response))
            },
            error => {
              dispatch(apiFailure(contracterConstants.ISSUE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}

/**
 * 물품정보 조회 팝업 호출
 * @returns {{type: string}}
 */
function isShowItems(isShow) {
  return {
    type: contracterConstants.SHOW_POPUP_ITEMS,
    isShow: isShow,
  }
}

/**
 * 물품정보 팝업 아이템 선택
 * @returns {{type: string}}
 */
function selectItems(itemSeq) {
  return {
    type: contracterConstants.SELECT_POPUP_ITEMS,
    itemSeq: itemSeq,
  }
}

/**
 * 임시저장 함수호출 초기화
 * @returns {{type: string}}
 */
function setCalled(called) {
  return {
    type: contracterConstants.RESET_CALLED,
    called: called,
  }
}


/***********
 컨트랙터 셋팅
************/

function setContracter(params) {
  return async dispatch => {
    dispatch(apiRequest(contracterConstants.CONTRACTER_REQUEST))

    defaultService.handleService(
      'post',
      '/swg/contract/read/getContractInfo.do',
      'cntrctNo=' + params.cntrctNo +
      '&menuId=101' +
      '&tmp='
    )
    .then(
      response => {
        dispatch(apiSuccess(contracterConstants.CONTRACTER_SUCCESS, response))
      },
      error => {
        dispatch(apiFailure(contracterConstants.CONTRACTER_FAILURE, error))
        dispatch(apiError(error))
      }
    )
  }
}


/***********
 컨트랙터 오픈
 ************/

function contracter() {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: contracterConstants.CONTRACTER_REQUEST
    }
  }
}

/***********
 컨트랙터 닫기
************/

function close() {
  return async dispatch => {
    dispatch(toggle())
  }
  function toggle() {
    return {
      type: contracterConstants.CONTRACTER_CLOSE
    }
  }
}

/***********
 컨트랙터 타입
************/

function toggleType() {
  return async dispatch => {
    dispatch(toggle())
  }
  function toggle() {
    return {
      type: contracterConstants.CONTRACTER_TOGGLE_TYPE
    }
  }
}

/***********
 가이드 타입
************/

function guideType(guideType) {
  return async dispatch => {
    dispatch(request(guideType))
  }
  function request(guideType) {
    return {
      type: contracterConstants.CONTRACTER_GUIDE_TYPE,
      guideType
    }
  }
}

/**
 * 경고창
 * @param params
 * @returns {function(*): Promise<void>}
 */

function alert(params) {
  return async dispatch => {
    dispatch(alertActions[params.type]({
      title: params.title,
      message: params.message
    }))
  }
}


/**
 * API응답처리 함수
 */
function apiRequest(type) {
  return {
    type: type
  }
}

function apiSuccess(type, response) {
  return {
    type: type,
    response
  }
}

function apiFailure(type, response) {
  return {
    type: type,
    response
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

